import type { Subquery } from '../../subquery'
import * as edge from '../edge'
import type { Context } from '../node/context'
import type { Node } from '../node/node'

import { determineIfResultsShouldBeSingleton } from './determine-if-results-should-be-singleton'

export type SubqueryNodeLookup = Partial<Record<Subquery.Name, Node>>
export namespace SubqueryNodeLookup {
  /**
   * TODO: explain
   */
  export function consume(
    consumer: Node,
    subqueryNodes: SubqueryNodeLookup,
    params: Node.constructor.Params & Pick<Context, 'schema'>,
  ): void {
    // TODO: find a way to make it so determineIfResultsShouldBeSingleton
    // is not dependent on this ordering
    // TODO: Consume only the entities that are actually used in the
    // selection
    // TODO: determine if the edge is required or not, this will be affected
    // by filters.
    consumer.edges.consuming.add(
      ...Object.values(subqueryNodes)
        .filter(edge.ForConsumption.isValidNode)
        .map<edge.ForConsumption>(node => ({
          isRequired: false,
          node,
          resultsAsSingleton: determineIfResultsShouldBeSingleton({
            consumedByNode: consumer,
            node,
            schema: params.schema,
          }),
        })),
    )
  }
}
